import React from 'react';

const AboutUs = props => (
  <React.Fragment>
    Apartmani Mima se nalaze u strogom centru Sokobanje. Svaki apartman poseduje spavaću sobu, dnevni boravak sa trpezarijom i kuhinjom, individualno kupatilo, kablovsku televiziju, klima uređaj, terasu. Apartmani su moderno opremljeni kako bi vam ulepšali boravak.
  </React.Fragment>
)

export default AboutUs;